<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <ValidationObserver v-slot="{ failed, passed }">
          <form>
            <md-card class="p-25">
              <md-card-content>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <p
                      style="
                        position: absolute;
                        top: 37px;
                        right: 24px;
                        color: red;
                      "
                      class="validate"
                    >
                      *
                    </p>

                    <model-list-select
                      class="input-must-rtl"
                      :list="employees"
                      v-model="EmployeeId"
                      option-value="key"
                      option-text="value"
                      placeholder="الموظف"
                    ></model-list-select>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <p class="validate">*</p>

                      <model-list-select
                        class="input-must-rtl"
                        :list="rewardNameList"
                        v-model="rewardName"
                        option-value="id"
                        option-text="rewardName"
                        placeholder="اسم المكافأة"
                      ></model-list-select>
                      <button
                        @click="clear_rewardName"
                        type="button"
                        class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                        tabindex="-1"
                      >
                        <div class="md-ripple">
                          <div class="md-button-content">
                            <i
                              class="md-icon md-icon-font md-icon-image md-theme-default"
                              ><svg
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                ></path>
                                <path d="M0 0h24v24H0z" fill="none"></path></svg
                            ></i>
                          </div>
                        </div>
                      </button>
                    </md-field>
                  </div>

                  <!-- <div class="md-layout-item md-size-30  md-small-size-100 ml-15 mt-25">
                    <md-field>
                      <p class="validate">*</p>
                      <label>نوع المكافأة</label>
                      <md-select v-model="rewardType">
                        <md-option value="1">مكافآت خاضعة لضريبة الجهاد</md-option>
                        <md-option value="2">مكافآت خاضعة لكافة الضرائب</md-option>
                      </md-select>
                    </md-field>
                  </div> -->

                  <div
                    v-if="calculatingtherewardvalueName == 'نسبة'"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>نسبة</label>
                      <md-input
                        disabled
                        v-model="percentage"
                        type="number"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    v-if="calculatingtherewardvalueName == 'نسبة'"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>القيمة المرجعية</label>
                      <md-input
                        v-model="refrencevalue"
                        type="number"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    v-if="
                      calculatingtherewardvalueName == 'قيمة ثابتة' ||
                      calculatingtherewardvalueName == 'نسبة'
                    "
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>القيمة</label>
                      <md-input
                        disabled
                        v-model="value"
                        type="number"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    v-if="calculatingtherewardvalueName == 'قيمة متغيرة'"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>القيمة</label>
                      <md-input v-model="value2" type="number"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>سبب المكافأة</label>
                      <md-input v-model="rewardReason" type="text"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-layout-item-time md-size-30 md-small-size-100 ml-15"
                    style="position: relative"
                  >
                    <p class="validate" style="right: 0px">*</p>
                    <h4
                      class="monthly-picker-head"
                      :class="{ active: dateToGet }"
                    >
                      شهر تحصيل المكافأة
                    </h4>
                    <vue-monthly-picker
                      class="monthly-picker"
                      alignment="right"
                      v-model="dateToGet"
                    />
                  </div>

                  <div
                    class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                  >
                    <md-button class="md-success btn_nanosoft" @click="Save"
                      >حفظ</md-button
                    >
                    <md-button class="md-info btn_nanosoft" @click="clear"
                      >جديد</md-button
                    >
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">البحث</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout mt-25">
            <div class="md-layout-item md-size-30 md-small-size-100 ml-15">
              <model-list-select
                class="input-must-rtl"
                :list="employees"
                v-model="employeeSearch"
                option-value="key"
                option-text="value"
                placeholder="الموظف"
              ></model-list-select>
            </div>

            <div class="md-layout-item md-size-30 md-small-size-100 ml-15">
              <md-field>
                <model-list-select
                  class="input-must-rtl"
                  :list="rewardNameList"
                  v-model="rewardNameSearch"
                  option-value="rewardName"
                  option-text="rewardName"
                  placeholder="اسم المكافأة"
                ></model-list-select>
              </md-field>
            </div>

            <div class="md-layout-item md-size-30 md-small-size-100 ml-15">
              <md-datepicker :md-open-on-focus="false" v-model="fromSearch">
                <label class="mr-28">من تاريخ</label>
              </md-datepicker>
            </div>

            <div
              class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
            >
              <md-datepicker :md-open-on-focus="false" v-model="toSearch">
                <label class="mr-28">الى تاريخ</label>
              </md-datepicker>
            </div>

            <div class="md-layout-item md-size-100 ml-15 center-content mt-25">
              <md-button class="md-success btn_nanosoft" @click="Search"
                >بحث</md-button
              >
              <md-button class="md-info btn_nanosoft" @click="confirm"
                >إعتماد</md-button
              >
              <md-button class="md-info btn_nanosoft" @click="UnConfirm"
                >إلغاء الإعتماد</md-button
              >
              <md-button class="md-danger btn_nanosoft" @click="deleteSelected"
                >حذف</md-button
              >
            </div>
          </div>

          <div class="md-layout flex-content-left">
            <div class="md-layout-item md-size-20">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option :value="5">5</md-option>
                      <md-option :value="25">25</md-option>
                      <md-option :value="50">50</md-option>
                      <md-option :value="75">75</md-option>
                      <md-option :value="100">100</md-option>
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-checkbox @change="selectAll" v-model="All"
                >اختيار الكل</md-checkbox
              >
            </div>
          </div>

          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell>
                <div class="md-layout-item md-size-20 center-content">
                  <md-checkbox
                    v-model="item.isActive"
                    @change="add(item)"
                  ></md-checkbox>
                </div>
              </md-table-cell>
              <md-table-cell md-label="الموظف">
                {{ item.employeeName }}
              </md-table-cell>

              <md-table-cell md-label="اسم المكافأة">
                {{ item.rewardName }}
              </md-table-cell>
              <md-table-cell md-label="قيمة المكافأة">
                {{ item.value }}
              </md-table-cell>

              <md-table-cell md-label="شهر تحصيل المكافأة">
                {{ formatDate(item.dateToGet) }}
              </md-table-cell>

              <md-table-cell md-label="إعتماد">
                {{ item.isConfirmed == true ? "نعم" : "لا" }}
              </md-table-cell>
              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <!-- <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div> -->
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "../../../../components/service/HTTP";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import { SlideYDownTransition } from "vue2-transitions";
// import { extend } from "vee-validate";
// import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../env";
// extend("required", required);
// extend("numeric", numeric);
// extend("regex", regex);
// extend("confirmed", confirmed);
export default {
  async created() {
    this.init();
  },
  components: {
    Pagination,
    ModelListSelect,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
  },
  data() {
    return {
      All: false,
      rewardNameSearch: "",
      value2: null,
      calculatingtherewardvalueName: "",
      calculatingtherewardvalue: "",
      rewardName: "",
      rewardNameList: [],
      EmployeeId: "",
      rewardType: "",
      value: 0,
      percentage: 0,
      refrencevalue: 0,
      rewardReason: "",
      dateToGet: null,
      errorMessage: " ",
      /////////////////////
      employeeSearch: "",
      Hours: 0,
      ValueHour: 0,
      SumValue: 0,
      ExtraWorkDate: null,
      ExtraWorkDate_SH: null,
      ConfirmExtraWork: false,
      TypeOfOverTime: "true",
      ExtraWorkType: "",
      Selected: [],
      tableData: [],
      btn: "new",
      idTable: "",
      employees: [],
      updateStatus: "",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      searchedData: [],
      fuseSearch: null,
      currentSort: "Titel",
      currentSortOrder: "asc",
      Hour: "",
      fromSearch: null,
      toSearch: null,
    };
  },

  watch: {
    rewardName() {
      for (let index = 0; index < this.rewardNameList.length; index++) {
        if (this.rewardName == this.rewardNameList[index].id) {
          this.value = this.rewardNameList[index].value;
          this.percentage = this.rewardNameList[index].percentage;
          this.calculatingtherewardvalueName =
            this.rewardNameList[index].calculatingtherewardvalueName;
        }
      }
    },

    refrencevalue() {
      if (this.calculatingtherewardvalueName == "نسبة") {
        this.value = (this.percentage * this.refrencevalue) / 100;
      }
    },

    "pagination.perPage"() {
      this.Search();
    },

    "pagination.currentPage"() {
      this.Search();
    },
  },

  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM");
    },
    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    async Search() {
      try {
        this.tableData = [];
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (this.fromSearch == null) {
          this.fromSearch = "";
        } else {
          this.fromSearch = this.convert(this.fromSearch);
        }

        if (this.toSearch == null) {
          this.toSearch = "";
        } else {
          this.toSearch = this.convert(this.toSearch);
        }

        let result = await axios.get(
          `${env.HR()}/api/reward/filter?EmployeeId=${
            this.employeeSearch
          }&RewardName=${this.rewardNameSearch}&From=${this.fromSearch}&To=${
            this.toSearch
          }&PageSize=${this.pagination.perPage}&currentPage=${
            this.pagination.currentPage
          }`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        this.tableData = result.data.data.results;
        this.pagination.total = result.data.data.total;
        // this.tableData.forEach((x) => {
        //   x.isActive = false;
        // });
      } catch (error) {
        this.message(error);
      }
    },

    add(item) {
      if (item.isActive == true) {
        this.Selected.push(item.id);
      } else {
        for (let i = 0; i < this.Selected.length; i++) {
          if (this.Selected[i] == item.id) {
            this.Selected.splice(i, 1);
          }
        }
      }
    },
    selectAll() {
      if (this.All === true)
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].isActive = true;
          this.Selected.push(this.tableData[i].id);
        }
      else {
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].isActive = false;
          this.Selected.splice(i, 1);
        }

        this.Selected = [];
      }
    },

    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (!this.EmployeeId) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار الموظف   "
          );
        }

        // if (!this.rewardReason) {
        //   return this.notifyVue(
        //     "top",
        //     "center",
        //     "danger",
        //     "عفواً، الرجاء ادخال سبب المكافأة "
        //   );
        // }

        if (!this.dateToGet) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال  شهر تحصيل المكافأة "
          );
        }

        // if (!this.ValueHour) {
        //   return this.notifyVue(
        //     "top",
        //     "center",
        //     "danger",
        //     "عفواً، الرجاء ادخال قيمة الساعة "
        //   );
        // }

        // if (!this.ExtraWorkType) {
        //   return this.notifyVue(
        //     "top",
        //     "center",
        //     "danger",
        //     "عفواً، الرجاء اختيار نوع العمل الإضافي "
        //   );
        // }

        // if (this.calculatingtherewardvalueName == 'نسبة') {
        //   this.value = this.refrencevalue * this.percentage;
        // }

        // this.value = 400;

        let schema = {
          EmployeeId: this.EmployeeId,
          rewardNameid: this.rewardName,
          value:
            this.calculatingtherewardvalueName == "قيمة متغيرة"
              ? parseInt(this.value2)
              : parseInt(this.value),
          percentage: this.percentage,
          refrencevalue: this.refrencevalue,
          rewardReason: this.rewardReason,
          dateToGet: new Date(
            moment(this.dateToGet).format("YYYY/MM/DD hh:mm:ss")
          ),
        };

        if (this.btn === "new") {
          let result = await axios.post(`${env.HR()}/api/reward`, schema, {
            headers: { Authorization: "Bearer " + token },
          });
        } else {
          let result = await axios.put(
            `${env.HR()}/api/reward/${this.idTable}`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        }
        this.btn = "new";
        this.init();
        this.clear();
        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        this.message(error);
      }
    },

    async confirm() {
      try {
        if (this.Selected.length < 1) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار موظف من الجدول "
          );
        }

        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let result = await axios.patch(
          `${env.HR()}/api/reward/confirm`,
          this.Selected,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        this.init();
        this.Selected = [];
        this.All = false;
        return this.notifyVue(
          "top",
          "center",
          "success",
          " تم الإعتماد بنجاح "
        );
      } catch (error) {
        this.message(error);
      }
    },

    async UnConfirm() {
      try {
        if (this.Selected.length < 1) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار موظف من الجدول "
          );
        }
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let result = await axios.patch(
          `${env.HR()}/api/reward/unConfirm`,
          this.Selected,

          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        this.init();
        this.Selected = [];
        this.All = false;
        return this.notifyVue("top", "center", "success", "تم إلغاء الإعتماد");
      } catch (error) {
        this.message(error);
      }
    },

    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(`${env.HR()}/api/reward`, {
          headers: { Authorization: "Bearer " + token },
        });

        let result2 = await axios.get(
          `${env.HR()}/api/Reward/GetTypesOfRewards`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        this.rewardNameList = result2.data.data.results;
        this.calculatingtherewardvalue =
          result2.data.data.results.calculatingtherewardvalue;
        this.employees = result.data.data.employees;
        this.tableData = result.data.data.employeesRewards.results;
      } catch (error) {
        this.message(error);
      }
    },

    clear() {
      (this.EmployeeId = ""),
        (this.rewardName = ""),
        (this.value = null),
        (this.rewardReason = ""),
        (this.refrencevalue = 0),
        (this.dateToGet = null),
        (this.btn = "new");
      this.idTable = "";
    },
    clear_rewardName() {
      this.rewardName = " ";
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },

    handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });

      (this.EmployeeId = item.employeeId),
        (this.rewardName = item.rewardNameID),
        (this.refrencevalue = item.refrenceValue),
        // (this.value = item.value),
        (this.value2 = item.value),
        (this.rewardReason = item.rewardReason),
        (this.dateToGet = item.dateToGet),
        (this.btn = "Edit");
      this.idTable = item.id;
    },

    async deleteSelected() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        // let schema = {
        //   Ids: this.Selected
        // };
        let { data } = await axios.delete(
          `${env.HR()}/api/reward`,

          {
            headers: { Authorization: "Bearer " + token },
            data: this.Selected,
          }
        );

        this.init();
        this.Selected = [];
        return this.notifyVue("top", "center", "success", data.message);
      } catch (error) {
        this.message(error);
      }
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/reward/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.deleteRow(item);
            this.init();
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            this.message(error);
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["Titel", "SystemVersion"],
      threshold: 0.3,
    });
  },
};
</script>

<style scoped>
.mt-37 {
  margin-top: 37px;
}
</style>
